<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onCreate">
    <v-card tile>
      <v-card-title class="grey lighten-2">
        Lägg till bemanningsavvikelser från THR
      </v-card-title>

      <v-card-text class="mt-2 pa-0">
        <MasterdataTableContainer
          show-select
          v-model="selected"
          :default-table-height="799"
          :loading="fetching"
          :headers="headers"
          :table-data="tableData"
          item-key="_uuid"
        >
          <v-menu
            slot="left"
            v-model="dateDialoag"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                rounded
                filled
                v-model="dateRangeText"
                dense
                :hide-details="true"
                v-on="on"
                v-bind="attrs"
                readonly
                prepend-inner-icon="mdi-calendar-range"
                class="mr-4"
              ></v-text-field>
            </template>
            <v-date-picker
              first-day-of-week="1"
              v-model="dates"
              range
            ></v-date-picker>
          </v-menu>
        </MasterdataTableContainer>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="closeModal">Avbryt</v-btn>
        <v-btn
          rounded
          type="submit"
          color="primary"
          :disabled="!selected.length"
          :loading="createPending"
        >
          Lägg till markerade
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import MasterdataTableContainer from '@/modules/masterdata/components/MasterdataTableContainer'
import { sync, get } from 'vuex-pathify'
import { required } from '@/common/validationRules'
import orderBy from 'lodash.orderby'
import { format, addDays } from 'date-fns'
import { v4 as uuidv4 } from 'uuid'
import gql from 'graphql-tag'

export default {
  name: 'CrewCreateThrModal',

  components: {
    MasterdataTableContainer
  },

  data: () => ({
    required,
    dateDialoag: false,
    valid: true,
    createPending: false,
    fetching: false,
    selected: [],
    unhandledCrewDeviations: [],
    dates: [
      format(addDays(new Date(), -1), 'yyyy-MM-dd'),
      format(new Date(), 'yyyy-MM-dd')
    ],
    headers: [
      {
        text: 'Tågnr.',
        value: 'train_number'
      },
      {
        text: 'Tjänstedatum',
        value: 'duty_date'
      },
      {
        text: 'Från plats',
        value: 'from'
      },
      {
        text: 'till plats',
        value: 'to'
      }
    ]
  }),

  computed: {
    model: sync('crew/model'),
    selectedEventUUID: get('event/selectedUUID'),

    datesSorted() {
      return orderBy(this.dates, [x => x], ['asc'])
    },

    dateRangeText() {
      return this.dates.join(' ~ ')
    },

    tableData() {
      return orderBy(
        this.unhandledCrewDeviations || [],
        ['duty_date'],
        ['desc']
      ).filter(x => !x.crew_deviation)
    }
  },

  watch: {
    dates: {
      handler: 'getUnhandledCrewDeviations',
      immediate: true
    }
  },

  methods: {
    async getUnhandledCrewDeviations() {
      if (this.datesSorted.length !== 2) return
      this.fetching = true
      const [from, to] = this.datesSorted
      this.unhandledCrewDeviations = await this.$store.dispatch(
        'linkDeviation/fetchStatelessUnhandledCrewDeviations',
        {
          from,
          to,
          district_id: this.$store.get('app/selectedDistrictId')
        }
      )
      this.fetching = false
    },

    async onCreate() {
      this.createPending = true

      for (let item of this.selected) {
        const model = {
          uuid: uuidv4(),
          event_uuid: this.selectedEventUUID,
          ...Object.keys(item)
            .filter(key =>
              ['duty_date', 'train_number', 'from', 'to'].includes(key)
            )
            .reduce((acc, next) => {
              acc[next] = item[next]
              return acc
            }, {})
        }

        await this.createCrew({
          ...model
        })
      }

      this.createPending = false

      this.closeModal()
    },

    async createCrew(payload) {
      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: CreateCrewDeviationInput!) {
            createCrewDeviation(payload: $payload) {
              crew_deviation_uuid
            }
          }
        `,
        variables: {
          payload
        }
      })

      this.$store.set(`crew/data@${payload.uuid}`, payload)

      this.$store.dispatch('linkDeviation/fetchUnhandledCrewDeviations', {
        district_id: this.$store.get('app/selectedDistrictId')
      })
    },

    closeModal() {
      this.$store.commit('crew/resetModel')
      this.$emit('close')
    }
  }
}
</script>
